import {useFormContext} from "react-hook-form";

import {Button} from "@/components/ui/button";
import {FormLabel} from "@/components/ui/form";
import {FieldHelpLabel} from "@/src/modules/help/components/field-help";
import {usePresetsDuration} from "@/src/modules/shifts/hooks";

import {SHIFT_FORM_HELP_KEYS} from "../../lib/shift-help";

interface PresetsDurationProps {
  isTemplate?: boolean;
}

export default function PresetsDuration({isTemplate}: PresetsDurationProps) {
  const {watch} = useFormContext();
  const {presetsDuration, onSelectPreset} = usePresetsDuration({isTemplate});
  const hasFromTime = !!watch("from_time");

  return (
    <div data-help-target={SHIFT_FORM_HELP_KEYS.presets}>
      <FieldHelpLabel helpKey={SHIFT_FORM_HELP_KEYS.presets} showIcon={false}>
        <FormLabel className="mb-2">Presets</FormLabel>
      </FieldHelpLabel>
      <div className="flex gap-2">
        {presetsDuration.map((hours) => (
          <Button
            key={`preset-duration-${hours}`}
            variant="outline"
            size="sm"
            type="button"
            className="px-2 text-xs"
            disabled={!hasFromTime}
            onClick={() => onSelectPreset(hours)}
          >
            {hours} h
          </Button>
        ))}
      </div>
    </div>
  );
}
